/**
 * Package configuration for the frontend.
 * Mirrors /app/backend/package_config.py — features must be kept in sync.
 *
 * The current package and subscription state are fetched at runtime from
 * /api/subscription/info via SubscriptionContext.
 */

export const PACKAGE_FEATURES = {
  core: new Set([
    "work_order", "work_order_labels",
    "store", "stock_out",
    "admin_dashboard", "admin_production", "admin_maintenance",
    "admin_database", "admin_security",
    "hr",
    // Quotation + Delivery Challan now included in Core (per customer spec Feb 2026)
    "quotations", "delivery_challans",
    // WO Progress Report — Core gets read-only visibility so Material Usage
    // completions show up (full admin_reports bundle stays Pro-only).
    "wo_progress",
    // Completion History — added to Core (per customer spec Feb 2026)
    "admin_history",
  ]),
  pro: new Set([
    "work_order", "work_order_labels",
    "store", "stock_out",
    "admin_dashboard", "admin_production", "admin_maintenance",
    "admin_database", "admin_security",
    "admin_timesheet", "admin_costing", "admin_history", "admin_reports",
    "accounts", "accounts_tally_export",   // Accounts Pro-only (Feb 2026)
    "hr",
    "employee_clock_in",   // Pro-only (shop floor employee portal)
    "quotations", "delivery_challans", "spd",
    "spd_display",         // Pro-only (the SPD Display card on Hub)
    "wo_progress",         // Pro-only (WO Progress tab + mobile card)
    "cost_calculator",
    "inventory_control",   // Pro-only (board-spec calculator → PO line items)
  ]),
};

/** Map a path to a feature key (or null if unrestricted). */
export const FEATURE_BY_PATH_PREFIX = [
  ["/spd", "spd"],
  ["/admin/cost-calculator", "cost_calculator"],
  ["/workorder/cost-calculator", "cost_calculator"],
  ["/admin/timesheet", "admin_timesheet"],
  ["/admin/completion-history", "admin_history"],
  ["/admin/reports", "admin_reports"],
  ["/wo-progress", "wo_progress"],
  ["/employee", "employee_clock_in"],
  ["/accounts", "accounts"],   // Pro-only (Feb 2026)
  ["/store/inventory-control", "inventory_control"],   // Pro-only
];

export const featureForPath = (pathname) => {
  for (const [prefix, feat] of FEATURE_BY_PATH_PREFIX) {
    if (pathname.startsWith(prefix)) return feat;
  }
  return null;
};
